<template>
  <footer class="footer">
    <div class="shopping-basket">
      <span class="material-icons">
        shopping_basket
      </span>
    </div>

    <router-link class="footer-title" :to="`/${cartLink}`">Ver mi pedido</router-link>
    $ {{ this.getSelectedProducts }}
    <div class="version">{{ getVersion }}</div>
  </footer>

  <!-- Footer -->
</template>
<script>
import footer_mixin from "../mixins/Footer_Mixin";
import { version } from "../../package.json";
export default {
  mixins: [footer_mixin],
  props: {
    cartLink: {
      type: String,
      default: "Checkout"
    }
  },
  computed: {
    getVersion() {
      return version;
    }
  },
  data() {
    return {};
  }
};
</script>
<style scoped>
.footer-title {
  font-weight: 600;
  text-decoration: none;
  color: black !important;
}
span {
  vertical-align: middle;
}
.shopping-basket {
  float: left;
  text-decoration: none;
  color: black !important;
}
.version {
  float: right;
  font-size: 10px;
  text-decoration: none;
  color: grey !important;
}
.footer {
  padding-left: 20px;
  padding-right: 20px;
  position: fixed;
  bottom: 0;
  width: 100%;
  min-height: 4em;
  background-color: #f0f0f0;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/Components/Footer.vue